import {types, flow, getEnv} from 'mobx-state-tree';
import * as api from '../../services/api';
import ChatChannelModel from '../chatChannelModel';
import WithFeedbackModel, {WithFeedbackActions} from '../composables/withFeedbackModel';

export type BotChatActions = {
  load: () => Promise<void>;
};

const BotChatModel = types.compose(
  WithFeedbackModel,
  types
    .model({
      channel: types.maybeNull(ChatChannelModel),
      loading: types.optional(types.boolean, false),
      loaded: types.optional(types.boolean, false)
    })
    .actions<BotChatActions>(self => {
      // tslint:disable-next-line:no-any
      const withActions = (self as any) as BotChatActions;

      // tslint:disable-next-line:no-any
      const withFeedback = (self as any) as WithFeedbackActions;

      return {
        load: flow(function*() {
          self.loading = true;

          let response = yield api.getBotChannel();

          if (response.data && response.status === 200) {
            self.channel = response.data.channel;
            self.channel!.loadCachedMessages();
          } else {
            withFeedback.sendErrorFeedback('Could not load the bot chat channel.');
          }

          self.loading = false;
          self.loaded = true;
        }),

        afterCreate: flow(function*() {
          if (getEnv(self).auth.profile) {
            yield withActions.load();
          }
        })
      };
    })
);

export type BotChat = typeof BotChatModel.Type;

export default BotChatModel;



// WEBPACK FOOTER //
// ./src/models/botChatModel/botChatModel.ts